


<html dir="{{direction}}" lang="en"  id="main" >

<app-top-nav-bar  (sidebarToggle)="toggleSidebar()"  ></app-top-nav-bar>  
<div class="main-layout">

<app-side-bar-menu [class.hidden]="isSidebarHidden"></app-side-bar-menu>       

<div class="main-content " >
  <router-outlet></router-outlet>  
</div>
</div>



 <!-- <i class="fa fa-globe d-flex justify-content-end my-1" style="align-items: end;" *ngIf="role=='Device' || currentUser==null"><select class="mx-2" #lang (change)="changeLangage(lang.value)">
    <option (click)="changeLangage('en')" value="en">EN</option>
    <option (click)="changeLangage('fr')" value="fr">FR</option>
  
   <option (click)="changeLangage('es')" value="es">ES</option>
  </select></i>
  
 


  <div class=" w-100" style="position:fixed; z-index: 100; " *ngIf="currentUser!=null && role!='Device' else emptyheader">
    <app-top-nav-bar (chattoggle)="notificationchat($event)" (htmldescription)="changeLangage($event)"></app-top-nav-bar>
  </div>

  <ng-template #emptyheader >
 
    </ng-template>




  <div class="container-fluid h-100 pt-5 bg-black">
    <div class="row h-100 pt-2">
      
     <app-side-bar-menu class="  rounded" *ngIf="currentUser!=null && role!='Device' && role!='Signage'" ></app-side-bar-menu>
   
   

       
           
          <div class="col mt-2 ">
        
              <router-outlet (activate)="onActivate($event)"> </router-outlet>       
          
           
      </div>
     
       
     
  </div>
</div>-->

     <!--<a href="" data-target="#sidebar" data-toggle="collapse" class="hidden-md-up"><i class="fa fa-bars"></i></a>-->
             <!--<div class="focus fab-container " *ngIf="loggedInUserId!='' && loggedInUserId!=null && role!='Device'">
                <button mat-fab class="focus fab-toggler" 
                (click)="toggleChat()" >
                  <i class="material-icons"  [@fabToggler]="{value: fabTogglerState}">message</i> 
               </button>
               </div> -->  
               <!--<app-chat id="chatwindow" style='height:25%; width:600px; margin-top:25%; width: 600px;;' class=" rounded" [hidden]="currentUser==null || chat==false  || role=='Device'" ></app-chat>-->
          <!--- End Navigation -->


</html>